import { Navigate, useParams } from "react-router-dom";
import { ROUTE_SLUGS, ROUTES } from "../config/navigation/routes";
import { fillRouteWithSlugs } from "../utils/navigation";

function DeviceTasks() {
  const { orgId = "", deviceId = "" } = useParams<{
    orgId: string;
    deviceId: string;
  }>();

  const tasksUrl = fillRouteWithSlugs(ROUTES.TASKS, {
    [ROUTE_SLUGS.ORG_ID]: orgId,
  });
  const target = deviceId ? `${tasksUrl}?deviceId=${deviceId}` : tasksUrl;

  return <Navigate to={target} replace />;
}

export default DeviceTasks;
